<template>
  <el-row class="chart-box">
    <el-col class="chart-title m-tb15">{{ data.title }}</el-col>
    <el-col class="chart-num m-b20">{{ data.total | formatPermil }}</el-col>
    <el-col><div class="" ref="chartContainer"></div> </el-col>
  </el-row>
</template>

<script>
import { Chart } from '@antv/g2'
import { formatPermil } from '@/common/filters'
export default {
  name: 'charts',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    renderChar() {
      if (this.chart) {
        this.chart.destroy()
      }
      const chart = new Chart({
        container: this.$refs.chartContainer,
        width: 260,
        height: 160,
        defaultInteractions: ['tooltip']
      })
      this.chart = chart
      chart.data(this.data.list)
      chart.scale({
        //日期x轴设置
        dt: {
          nice: true,
          tickInterval: 3
        },
        //数值y轴设置
        value: {
          nice: true
        }
      })
      chart.axis('value', {
        line: {
          //坐标轴线线
          style: {
            lineWidth: 1,
            stroke: '#E7E7E7'
          }
        },
        grid: {
          //网格线
          line: {
            style: {
              lineWidth: 1,
              stroke: '#E7E7E7'
            }
          }
        }
      })
      chart.axis('dt', {
        tickLine: null,
        grid: null,
        line: {
          style: {
            lineWidth: 1,
            stroke: '#E7E7E7'
          }
        }
      })
      chart.tooltip({
        showCrosshairs: true, // 展示 Tooltip 辅助线
        shared: true,
        crosshairs: {
          line: {
            style: {
              stroke: '#ccc',
              lineDash: [2, 2, 2]
            }
          }
        },
        customItems: items => {
          items[0].value = formatPermil(parseFloat(items[0].value))
          return items
        },
        itemTpl:
          '<li class="g2-tooltip-list-item">' +
          '<span class="g2-tooltip-marker" style="background-color:#D0111A;"></span>' +
          '<span>{value}</span>' +
          '</li>',
        'g2-tooltip-value': {
          marginLeft: '-10px'
        },
        'g2-tooltip-marker': {
          width: '5px',
          height: '5px'
        }
      })
      chart
        .line()
        .position('dt*value')
        .color('#D0111A')

      chart.render()
    }
  },
  mounted() {
    this.renderChar()
  }
}
</script>
<style scoped lang="scss">
.chart-box {
  width: 295px;
  margin-right: 5px;
  .chart-title {
    font-size: 14px;
    color: #999;
  }
  .chart-num {
    font-weight: 600;
    font-size: 20px;
    color: #333;
  }
}
</style>
